import { getAxios } from '@/helpers/axios-helper';
import { DEFAULT_USERSETTINGS, UserSettings } from '@/stores/useUserStoreTypes';
import { captureMessageForSentry } from '@/libraries/sentry';

export async function getSettings(
	justwatch_id = '',
	locale = '',
	accessToken = '',
	source: string
): Promise<UserSettings> {
	// don't fetch personalized data when jwId is not available
	if (!justwatch_id) return Promise.resolve(DEFAULT_USERSETTINGS);

	try {
		const response = await getAxios().get(`${JW_CONFIG.WRITE_URL}/settings/${locale}`, {
			params: { justwatch_id },
			headers: { 'X-Access-Token': accessToken },
		});

		const {
			onboarding_status,
			taste_survey_completed: _taste_survey_completed,
			taste_survey_model_version: _taste_survey_model_version,
			taste_survey_type: _taste_survey_type,
			hidden_timeline_specials: _hidden_timeline_specials,
			...settings
		} = response.data;

		return { ...settings, onboardingStatus: onboarding_status };
	} catch (error: any) {
		const status = error.response?.status;
		captureMessageForSentry(
			`[getSettings()] - ${status}. Source: ${source}`,
			{ error, where: 'settings-helper.ts' },
			'error'
		);

		return Promise.resolve(DEFAULT_USERSETTINGS);
	}
}

export async function mutateSettings(
	justwatch_id = '',
	accessToken = '',
	locale = '',
	currentSettings: UserSettings,
	newSettings: Partial<UserSettings>
) {
	if (!justwatch_id) return Promise.resolve(currentSettings || DEFAULT_USERSETTINGS);

	const mutations = [];
	for (const [field, value] of Object.entries(newSettings)) {
		if (field === 'onboardingStatus') {
			mutations.push({
				field: 'onboarding_status',
				unset: (currentSettings as any)['onboarding_status'],
				set: value,
			});
		} else {
			mutations.push({
				field: field,
				unset: (currentSettings as any)[field],
				set: value,
			});
		}
	}

	try {
		const response = await getAxios().post(
			`${JW_CONFIG.WRITE_URL}/settings/${locale}/mutate`,
			{ mutations },
			{ params: { justwatch_id }, headers: { 'X-Access-Token': accessToken } }
		);
		const {
			onboarding_status,
			taste_survey_completed: _taste_survey_completed,
			taste_survey_model_version: _taste_survey_model_version,
			taste_survey_type: _taste_survey_type,
			hidden_timeline_specials: _hidden_timeline_specials,
			...settings
		} = response.data;
		return { ...settings, onboardingStatus: onboarding_status };
	} catch (error: any) {
		const status = error.response?.status;
		captureMessageForSentry(`[mutateSettings()] - ${status}`, { error, where: 'settings-helper.ts' }, 'error');

		return Promise.resolve(currentSettings || DEFAULT_USERSETTINGS);
	}
}
